export default "__VITE_ASSET__BRWOU6W9__"